import {
  LOG_IN,
  LOG_OUT,
  SET_USER,
  SET_LOADING,
  COMPLETED_DATA,
  INTERRUPT_TENNIS,
  INTERRUPT_X10,
  INTERRUPT_SAISON,
  INTERRUPT_RENOUVELLEMENT_SAISON,
  SET_SOCIAL_NETWORKS,
  INTERRUPT_RENDEZ_VOUS
} from '../actions/actions'

const initialState =
{
  loggedIn: false,
  user: {},
  completedData : JSON.parse(localStorage.getItem('completedData') || true) ,
  loading: false,
  accessToken: (localStorage.getItem('accessToken') || null),
  interruptionTennis: true
}

const user = (state = initialState, action) => {
  switch (action.type) {
  case LOG_IN:
    return {
      ...state,
      loggedIn: true
    }

  case LOG_OUT:
    localStorage.removeItem('accessToken')
    localStorage.setItem('completedData', true)

    if (state?.ssoConnected) {
      window.location.href = process.env.REACT_APP_API_PATH + 'api/auth/logout'
    }

    return {
      ...state,
      loggedIn: false,
      user: {},
      accessToken: null,
      completedData : true
    }

  case SET_USER:
    localStorage.setItem('accessToken', action.payload.accessToken)
    return {
      ...state,
      user: action.payload.userObj,
      accessToken: action.payload.accessToken,
      ssoConnected: action.payload.ssoConnected
    }
  case SET_LOADING:
    return {
      ...state,
      loading: action.payload
    }
  case INTERRUPT_RENDEZ_VOUS:
    return {
      ...state,
      interruptionRendezVous: action.payload
    }

  case COMPLETED_DATA:
    localStorage.setItem('completedData', action.payload)
    return {
      ...state,
      completedData: action.payload
    }

  case INTERRUPT_TENNIS:
    return {
      ...state,
      interruptionTennis: action.payload
    }

  case INTERRUPT_X10:
    return {
      ...state,
      interruptionX10: action.payload
    }

  case INTERRUPT_SAISON:
    return {
      ...state,
      interruptionSaison: action.payload
    }

  case INTERRUPT_RENOUVELLEMENT_SAISON:
    return {
      ...state,
      interruptionRenouvellementSaison: action.payload
    }

  case SET_SOCIAL_NETWORKS:
    return {
      ...state,
      socialNetworks: action.payload
    }
  
  default:
    return state
  }
}

export default user
